<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .integration-modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
</style>

<script>
  // Components
  import TabPanel from "@sourcewhale/shared/svelte-design-system/components/molecules/TabPanel.svelte";
  import ActivityNotes from "../sections/ActivityNotes/ActivityNotes.svelte";
  import ContactFields from "../sections/ContactFields/ContactFields.svelte";
  import ContactLevelSettings from "../sections/ContactSettings/ContactSettings.svelte";
  import ContactStages from "../sections/ContactStages/ContactStages.svelte";
  import DataRefresh from "../sections/DataRefresh/DataRefresh.svelte";
  import GeneralSettings from "../sections/GeneralSettings/GeneralSettings.svelte";
  import { hasGeneralSettingsData } from "../sections/GeneralSettings/utils";
  import Notetaker from "../sections/Notetaker/Notetaker.svelte";
  // Stores
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import { integrationStore, isDataRefreshTab } from "../stores";

  $: hasStages = !!$integrationStore.getSettings("stages").length;

  $: generalSettings = $integrationStore.getSettings("general");
  $: hasGeneralSettings = hasGeneralSettingsData(generalSettings);

  $: tabItems = [
    {
      label: "Contact Settings",
      slot: "tab0",
      snippet: dynamicTabSnippet,
    },
    {
      label: "Activity Notes",
      slot: "tab1",
      snippet: dynamicTabSnippet,
    },
    // Only include Contact Stages if hasStages is true
    ...(hasStages
      ? [
          {
            label: "Contact Stages",
            slot: "tab2",
            snippet: dynamicTabSnippet,
          },
        ]
      : []),
    {
      label: "Contact Fields",
      slot: "tab3",
      snippet: dynamicTabSnippet,
    },
    // Only include General Settings if hasGeneralSettings is true
    ...(hasGeneralSettings
      ? [
          {
            label: "General Settings",
            slot: "tab4",
            snippet: dynamicTabSnippet,
          },
        ]
      : []),
    {
      label: "Data Refresh",
      slot: "tab5",
      showPadlock: !$userStore.dataRefresh,
      snippet: dynamicTabSnippet,
    },
    {
      label: "Notetaker",
      slot: "tab6",
      showPadlock: !$userStore.notetakerPlan,
      snippet: dynamicTabSnippet,
    },
  ];

  let activeTab = tabItems?.length ? tabItems[0].slot : null;

  $: $isDataRefreshTab = activeTab === "tab5";
</script>

{#snippet dynamicTabSnippet()}
  {@const activeTabItem = tabItems.find((item) => item.slot === activeTab)}
  {@const tabSlot = activeTabItem?.slot}

  {#if tabSlot === "tab0"}
    <ContactLevelSettings />
  {:else if tabSlot === "tab1"}
    <ActivityNotes />
  {:else if tabSlot === "tab2"}
    <ContactStages />
  {:else if tabSlot === "tab3"}
    <ContactFields />
  {:else if tabSlot === "tab4"}
    <GeneralSettings />
  {:else if tabSlot === "tab5"}
    <DataRefresh />
  {:else if tabSlot === "tab6"}
    <Notetaker />
  {/if}
{/snippet}

<div class="integration-modal-content">
  <TabPanel type="vertical" {tabItems} modalVertical bind:activeTab />
</div>
